import React from 'react'
import {useStyles} from "./ScoredSceneCardBasic.css";
import {Card, Divider} from "@mui/material";
import AssociationLogo from "../../../../../commons/utils/logo/AssociationLogo";
import {useIntl} from "react-intl";
import ScoredSceneStatusIndication from "../../../../../commons/utils/status/scoredScene/ScoredSceneStatusIndication";
import {NavLink} from "react-router-dom";
import logo from 'assets/judged_quadratic_transparent.png';

const ScoredSceneCardBasic = ({
                                  scoredScene,
                                  headerSize,
                                  textSize,
                                  enrichedComponentTop,
                                  enrichedComponentBottom,
                                  enrichedComponentHeader,
                                  enrichedComponentBody,
                                  thumbnailHeight = 120,
                                  logoSize = 30,

                                  // True is only allowed in case it is used within react-router-dom
                                  clickable = false
                              }) => {
    const classes = useStyles({headerSize: headerSize, textSize: textSize})

    // Internationalization for simple strings
    const intl = useIntl();

    const card = (
        <Card className={classes.root}>

            {/* Optional component top */}
            <div>
                {enrichedComponentTop}
            </div>

            {/* Standard content */}
            <div className={classes.videoCard}>

                {/* If the scene card is rendered by a player role, the scored scene's score definitions are explicitely
                    set to null in the backend to prevent cheating. */}
                <div>
                    <img src={scoredScene.scoreDefinitions
                        ? scoredScene.scoreDefinitions[0].thumbnails?.size200
                        : logo}
                         height={thumbnailHeight}
                         alt="Thumbnail of the first score"/>
                </div>
                <div className={classes.videoCardContent}>

                    {/* Header row */}
                    <div className={classes.spacedRow}>
                        <div className={classes.row}>
                            <AssociationLogo association={scoredScene.video.basics.association}
                                             height={logoSize}
                                             width={logoSize}/>
                            <div className={classes.discipline}>
                                {intl.formatMessage({id: `app.ids.discipline.${scoredScene.video.basics.discipline}`})}
                                <span> - </span>
                                {intl.formatMessage({
                                    id: `app.ids.ageGroup.${scoredScene.video.basics.ageGroup}`
                                })} ({intl.formatMessage({
                                id: `app.ids.gender.${scoredScene.video.basics.gender}`
                            })})
                            </div>
                        </div>
                        <ScoredSceneStatusIndication statusInfo={scoredScene.statusInfo} size="small"/>

                        {/* Optional component right to the header */}
                        <div>
                            {enrichedComponentHeader}
                        </div>
                    </div>
                    <Divider orientation={"horizontal"} style={{width: "100%"}}/>

                    {/* Description row */}
                    <div className={classes.spacedRow}>
                        <div className={classes.description}>
                            <div>
                        <span>
                            {scoredScene.video.basics.tournament} ({scoredScene.video.basics.year})
                        </span>
                            </div>
                            <div>
                        <span>
                            <b>{scoredScene.video.basics.surnameAthlete1}</b> vs. <b>{scoredScene.video.basics.surnameAthlete2}</b> ({intl.formatMessage({
                            id: `app.ids.bout.${scoredScene.video.basics.bout}`
                        })})
                        </span>
                            </div>
                        </div>
                    </div>

                    {/* Optional component at the vertical end of the body */}
                    <div>
                        {enrichedComponentBody}
                    </div>

                </div>
            </div>

            {/* Optional component at the bottom */}
            <div>
                {enrichedComponentBottom}
            </div>
        </Card>
    )

    if (clickable) {
        return <NavLink style={{textDecoration: 'none'}}
                        to={`/admin/videos/${scoredScene.video.key}/scoredScenes/${scoredScene.key}/edit`}>
            {card}
        </NavLink>
    }

    return card
}

export default ScoredSceneCardBasic
